import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IKhuCongNghiep } from 'app/shared/model/khu-cong-nghiep.model';
import { getEntities as getKhuCongNghieps } from 'app/entities/khu-cong-nghiep/khu-cong-nghiep.reducer';
import { IDoanhNghiep } from 'app/shared/model/doanh-nghiep.model';
import { getEntity, updateEntity, createEntity, reset } from './doanh-nghiep.reducer';

export const DoanhNghiepUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const khuCongNghieps = useAppSelector(state => state.khuCongNghiep.entities);
  const doanhNghiepEntity = useAppSelector(state => state.doanhNghiep.entity);
  const loading = useAppSelector(state => state.doanhNghiep.loading);
  const updating = useAppSelector(state => state.doanhNghiep.updating);
  const updateSuccess = useAppSelector(state => state.doanhNghiep.updateSuccess);
  const handleClose = () => {
    props.history.push('/doanh-nghiep');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getKhuCongNghieps({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...doanhNghiepEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...doanhNghiepEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="xtdtApp.doanhNghiep.home.createOrEditLabel" data-cy="DoanhNghiepCreateUpdateHeading">
            <Translate contentKey="xtdtApp.doanhNghiep.home.createOrEditLabel">Create or edit a DoanhNghiep</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doanh-nghiep-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('xtdtApp.doanhNghiep.ten')} id="doanh-nghiep-ten" name="ten" data-cy="ten" type="text" />
              <ValidatedField label={translate('xtdtApp.doanhNghiep.ma')} id="doanh-nghiep-ma" name="ma" data-cy="ma" type="text" />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doanh-nghiep" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoanhNghiepUpdate;
